import React, { useState } from "react";
import "./SignIn.css";
import backgroundImage from "./background.png";
import { useGoogleLogin } from "@react-oauth/google";
import { FaGoogle, FaFacebook, FaApple } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setSession, takeSignOutReason } from "./utils/auth";
import { isDemo } from "./config";

const SignIn = () => {

  const navigate = useNavigate();
  // A demo host has one shared account: no other way in, and nothing to sign up for.
  const accountOptions = !isDemo();
  const [formData, setFormData] = useState({ identifier: "", password: "" });
  // Read once in the initialiser and cleared as it is read, so it cannot show up on
  // the next deliberate sign-out.
  const [error, setError] = useState(() => takeSignOutReason());
  const [loading, setLoading] = useState(false);


  // Authorization-code flow: the browser never holds a Google token. Navigate only
  // AFTER the backend answers.
  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async ({ code }) => {
      setError(null);
      setLoading(true);
      try {
        const { data } = await axios.post("/api/userflow/google", { code });
        setSession({ token: data.token, userId: data.userId });
        navigate("/home", { replace: true });
      } catch (err) {
        setError(err.response?.data?.message || "Google sign-in failed");
      } finally {
        setLoading(false);
      }
    },
    onError: (err) => {
      console.error("Google sign-in failed:", err);
      setError("Google sign-in was cancelled or blocked");
    },
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axios.post("/api/userflow/login", formData);
      const { token, userId } = response.data;
      setSession({ token, userId });
      navigate("/home");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="overlay"></div>
      <div className="content">
        <div className="branding">
          <h1 className="main-text">
            uTECH <span className="overlay-text">Mobility Analyzer</span>
          </h1>
        </div>
        <form className="login-box" onSubmit={handleSubmit}>
          <input type="text" name="identifier" placeholder={accountOptions ? "Email or phone number" : "Username"}
                 aria-label={accountOptions ? "Email or phone number" : "Username"} autoComplete="username"
                 value={formData.identifier} onChange={handleChange} required />
          <input type="password" name="password" placeholder="Password" aria-label="Password" autoComplete="current-password"
                 value={formData.password} onChange={handleChange} required />
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Signing in…" : "Log In"}
          </button>
          {error && <div className="login-error">{error}</div>}
          {accountOptions && (
            <>
              <div className="divider">OR</div>
              {/* type="button" is not cosmetic: these sit inside the <form>, and a button
                  with no type defaults to submit -- so clicking Google also ran the
                  email/password submit. */}
              <div className="social-icons">
                <button type="button" className="social-btn" onClick={login} disabled={loading}>
                  <FaGoogle />
                </button>
                <button type="button" className="social-btn"><FaFacebook /></button>
                <button type="button" className="social-btn"><FaApple /></button>
              </div>
              <p className="forgot-password">Forgot password?</p>
              <p className="signup">Don’t have an account? <span onClick={() => navigate("/signup", { replace: true })}>Sign up</span></p>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default SignIn;
